import { PopoutChildState, setPopoutChildState } from 'owa-popout-v2';
import { action } from 'satcheljs/lib/legacy';

export let deepLinkInboxForMeRouteHandler = action('deepLinkInboxForMeRouteHandler')(
    function deepLinkInboxForMeRouteHandler() {
        setPopoutChildState(PopoutChildState.Ready);
    }
);
